module.exports = __webpack_public_path__ + "img/yl3032.c5770831.png";